<template>
  <el-popover
    :width="width"
    ref="popover"
    placement="bottom-start"
    trigger="click"
    :popper-class="isBodyPadding ? '' : 'cust-popper-play'"
    transition="none"
  >
    <template #reference>
      <slot name="conent"></slot>
    </template>
    <template #default>
      <slot name="popConent"></slot>
    </template>
  </el-popover>
</template>
<script setup>
const props = defineProps({
  width: {
    type: String,
    default: '150',
  },
  isBodyPadding: {
    type: Boolean,
    default: true,
  },
})
const router = useRouter()
const popover = ref()
// 手动聚焦
const handleCloseFn = val => {
  popover.value?.hide()
}
defineExpose({
  handleCloseFn,
})
</script>
<style lang="scss">
.cust-popper-play {
  padding: 0 !important;
}
</style>
